import React from "react"

export const BackSvg = () => (
  <svg
    width="22"
    height="19"
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9995 9.18176L0.999512 9.18176"
      stroke="#04063E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.18115 17.3636L0.999335 9.18183L9.18115 1.00001"
      stroke="#04063E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
